import { type InputHTMLAttributes, type ReactNode } from "react";
import cx from "classix";

interface BaseInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "children"> {
    children?: ReactNode;
    overlay?: ReactNode;
}

export default function BaseInput({ children, type = "text", overlay, ...rest }: BaseInputProps) {
    return (
        <label className="group">
            <span className="text-sm text-secondary-10 group-has-focus-within:text-secondary-50 block -mb-1 mx-1">
                {children}
            </span>

            <div className="relative">
                <input
                    type={type}
                    className={cx(
                        "border border-solid border-input/20 outline-0 rounded-lg p-2 w-full mt-1 bg-input/5 text-base disabled:bg-input/25 disabled:text-secondary-02",
                        "focus-within:border-input/30 focus-within:bg-input/15"
                    )}
                    {...rest}
                />
                {overlay}
            </div>
        </label>
    );
}